var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.routePath)?_c('f7-fab',{attrs:{"color":"white","position":"left-top"},on:{"click":_vm.click}},[_c('FlatIcon',{attrs:{"name":"route-active","size":32}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }